import { useQuery } from '@tanstack/react-query';
import { congesApi } from '../services/conges-api';

/**
 * Les types d'arrêt saisissables, lus du RÉFÉRENTIEL.
 *
 * Ils étaient écrits en dur dans l'écran : quatre valeurs sur les seize de la
 * catégorie Santé. Un type ajouté ou renommé en base ne se voyait donc nulle
 * part, ce qui vide de son sens un référentiel administrable.
 *
 * Les libellés servent tels quels : c'est par le LIBELLÉ que le serveur relie
 * un arrêt à son type d'absence.
 */
export function useTypesArret() {
  const { data, isLoading } = useQuery({
    queryKey: ['conges', 'types-arret'],
    queryFn: () => congesApi.absencesRh.typesArret(),
    // Un référentiel ne bouge pas pendant une saisie.
    staleTime: 5 * 60 * 1000,
  });
  return { types: data?.types ?? [], chargement: isLoading };
}
